import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export default function CtaSection({ section }) {
  const { title, body, data = {} } = section;
  const ctaPrimary = data.cta_primary;
  const ctaSecondary = data.cta_secondary;

  return (
    <section className="py-16 sm:py-20" data-testid="section-cta">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35 }}
        >
          {title && <h2 className="font-display text-2xl sm:text-3xl font-medium tracking-[-0.015em] text-ink mb-4">{title}</h2>}
          {body && <p className="text-sm text-muted-foreground mb-8 max-w-md mx-auto">{body}</p>}
          <div className="flex flex-wrap gap-3 justify-center">
            {ctaPrimary && (
              <Link to={ctaPrimary.href}>
                <Button className="h-11 px-8 rounded-[12px] gap-2 shadow-[0_12px_26px_rgba(14,14,16,0.10)] active:scale-[0.98]">
                  {ctaPrimary.label} <ArrowRight className="h-4 w-4" />
                </Button>
              </Link>
            )}
            {ctaSecondary && (
              <Link to={ctaSecondary.href}>
                <Button variant="outline" className="h-11 px-8 rounded-[12px] active:scale-[0.98]">
                  {ctaSecondary.label}
                </Button>
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
